"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CardContainer = _interopRequireDefault(require("../cardContainer/CardContainer"));

var _Image = _interopRequireDefault(require("../../../atoms/images/image/Image"));

var _ListItem = _interopRequireDefault(require("../../../molecules/lists/ListItem"));

var _SystemIcon = _interopRequireDefault(require("../../../protons/icons/SystemIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CardMessages = function CardMessages(_ref) {
  var src = _ref.src,
      footerNote = _ref.footerNote,
      body = _ref.body,
      icon = _ref.icon,
      _action = _ref.action;
  return /*#__PURE__*/_react.default.createElement(_CardContainer.default, {
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Image.default, {
    ratio: "16x9",
    src: src
  }), /*#__PURE__*/_react.default.createElement(_ListItem.default, {
    action: function action(e) {
      return _action(e);
    },
    align: "top",
    endAdornment: /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
      color: "red",
      icon: "ic_chevron__right",
      size: "xLarge"
    }),
    footerNote: footerNote,
    intro: "",
    primary: "",
    secondary: body,
    startAdornment: /*#__PURE__*/_react.default.createElement(_SystemIcon.default, {
      color: "grey",
      icon: icon,
      size: "xLarge"
    })
  }));
};

CardMessages.propTypes = {
  /** The image url to show */
  src: _propTypes.default.string.isRequired,

  /** The body text of the card */
  body: _propTypes.default.string.isRequired,

  /** The footer note text */
  footerNote: _propTypes.default.string,

  /** The system party icon see #protons-icons-system--icon */
  icon: _propTypes.default.string.isRequired,

  /** The action of the list item card */
  action: _propTypes.default.func.isRequired
};
CardMessages.defaultProps = {
  footerNote: null
};
var _default = CardMessages;
exports.default = _default;